import { COUNTRY } from '../types/enums';

export const CURRENCY_MAPPER: Record<string, string> = {
  [COUNTRY.PE]: 'PEN',
  [COUNTRY.CO]: 'COP',
  [COUNTRY.CL]: 'CLP',
  [COUNTRY.BR]: 'BRL',
};
